/* -----------------UI--------------- */

import { useExamContext } from "@features/exam/contexts/ExamContext";
import useExams from "@hooks/useExams";
import { useLocalSearchParams } from "expo-router";

/* -----------------Child components--------------- */
import { ProductsList } from "@features/dashboard/components/Store/ProductsList";
import Loader from "@memorang/ui/src/components/Loader";

import { pageViewTypes } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import type { ExamDetails } from "@memorang/types/src/exams";

type Props = {
	handleNext: (step: string) => void;
};
export const ChooseExamContainer = ({ handleNext }: Props) => {
	const { param: selectedCategory } = useLocalSearchParams<{
		param: string;
		showBackButton: string;
	}>();

	const { handleSwitchExamContext } = useExamContext();

	const { groupedExams } = useExams();
	useAnalytics({
		type: pageViewTypes.chooseExam,
		selectedCategory,
	});

	if (!groupedExams.length) {
		return <Loader />;
	}

	const filteredExams = groupedExams.filter((exam) => {
		return selectedCategory
			? exam.title.toLocaleLowerCase() === selectedCategory?.toLocaleLowerCase()
			: true;
	});

	const interceptHandleSwitchExamContext = async (examDetails: ExamDetails) => {
		await handleSwitchExamContext(examDetails);
		handleNext("userdetails");
	};

	return (
		<ProductsList
			products={filteredExams}
			showProducts={false}
			showChevronRight
			handleSwitchExamContext={interceptHandleSwitchExamContext}
		/>
	);
};
